<!-- Button -->
<button
    mat-icon-button
    [matTooltip]="'ToggleFullScreen' | transloco"
    (click)="toggleFullscreen()"
>
    <ng-container [ngTemplateOutlet]="iconTpl || defaultIconTpl"></ng-container>
</button>

<!-- Default icon -->
<ng-template #defaultIconTpl>
    <mat-icon [svgIcon]="'heroicons_outline:arrows-pointing-out'" class="text-primary"></mat-icon>
</ng-template>
